var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{attrs:{"size":"small","placeholder":'请输入' + _vm.info.fieIdName,"rows":4,"label":_vm.info.fieIdName,"type":"textarea"},on:{"input":_vm.updateValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }